import { render, staticRenderFns } from "./TaskTypeCard.vue?vue&type=template&id=51a92fd7"
import script from "./TaskTypeCard.vue?vue&type=script&lang=js"
export * from "./TaskTypeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports